class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);
document.addEventListener('DOMContentLoaded', function () {
  // Fetch cart data on initial page load
  fetchCartData();

  // Fetch cart data after AJAX page navigation (if applicable)
  document.addEventListener('pageshow', function () {
    fetchCartData();
  });

  function fetchCartData() {
    fetch('/cart.js')
      .then((response) => response.json())
      .then((data) => {
        const cartCount = $('#header-cart-count-bubble');
        if (cartCount[0]) {
          cartCount[0].innerHTML = data.item_count;
        }
      });
  }
});
const trendingImg = ` <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"> <g id="increase 1"> <path id="Vector" d="M15.4516 3.85514L15.1547 6.71657C15.1204 7.03068 14.7351 7.16565 14.5142 6.94479L13.8124 6.24292L9.3926 10.6627C9.11529 10.94 8.62694 10.94 8.34963 10.6627L5.91522 8.22825L1.80224 12.3437C1.6599 12.486 1.47095 12.5597 1.28198 12.5597C1.09302 12.5597 0.904065 12.486 0.761726 12.3437C0.474607 12.0566 0.474607 11.5903 0.761726 11.3007L5.39497 6.66748C5.67227 6.39018 6.16063 6.39018 6.43548 6.66748L8.87235 9.10189L12.7718 5.20241L11.9497 4.38031C11.7264 4.15699 11.8614 3.77171 12.1755 3.73981L15.0369 3.44286C15.275 3.41587 15.4762 3.61711 15.4516 3.85514Z" fill="#8E8E93"/></g></svg>
  `;
const recentImg = ` <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"> <g id="clock-circular-outline 1"> <path id="Vector" d="M8 1C4.14014 1 1 4.14014 1 8C1 11.8599 4.14014 15 8 15C11.8599 15 15 11.8599 15 8C15 4.14014 11.8599 1 8 1ZM8 13.4699C4.98379 13.4699 2.53005 11.0162 2.53005 8C2.53005 4.98394 4.98379 2.53005 8 2.53005C11.0162 2.53005 13.4699 4.98394 13.4699 8C13.4699 11.0162 11.0162 13.4699 8 13.4699Z" fill="#8E8E93"/> <path id="Vector_2" d="M8.60589 8.00841V5.07455C8.60589 4.74697 8.34043 4.48151 8.01297 4.48151C7.68541 4.48151 7.41992 4.74697 7.41992 5.07455V8.19786C7.41992 8.20719 7.42222 8.21594 7.42267 8.22527C7.41487 8.38652 7.47042 8.55025 7.59358 8.67343L9.80223 10.8819C10.0339 11.1136 10.4094 11.1136 10.6408 10.8819C10.8723 10.6503 10.8725 10.2748 10.6408 10.0433L8.60589 8.00841Z" fill="#8E8E93"/></g></svg>
  `;
const searchImg = ` <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"> <g id="Search"> <path id="Union" fill-rule="evenodd" clip-rule="evenodd" d="M3.29816 7.21906C3.29816 4.69387 5.34523 2.64679 7.87043 2.64679C10.3956 2.64679 12.4427 4.69387 12.4427 7.21906C12.4427 9.74426 10.3956 11.7913 7.87043 11.7913C5.34523 11.7913 3.29816 9.74426 3.29816 7.21906ZM7.87043 1C4.43574 1 1.65137 3.78437 1.65137 7.21906C1.65137 10.6538 4.43574 13.4381 7.87043 13.4381C9.21931 13.4381 10.4679 13.0087 11.4869 12.2791L13.157 13.9449C13.479 14.266 14.0004 14.2654 14.3215 13.9434C14.6426 13.6214 14.642 13.1001 14.32 12.7789L12.6885 11.1517C13.5642 10.0801 14.0895 8.71091 14.0895 7.21906C14.0895 3.78437 11.3051 1 7.87043 1Z" fill="#8E8E93"/></g></svg>
  `;
let maxRetries = 5;
function getPopularSearch() {
  let popularSearch = window.Searchanise?.preloadedSuggestions;

  if (!popularSearch?.length) {
    popularSearch = localStorage.getItem('popularSearch')
      ? JSON.parse(localStorage.getItem('popularSearch'))
      : '';
    return popularSearch;
  }
  localStorage.setItem(
    'popularSearch',
    JSON.stringify(popularSearch.slice(0, 5)),
  );
  return popularSearch.slice(0, 5);
}
function getRecentSearch() {
  try {
    const recentSearches = localStorage.getItem('search-recent')
      ? JSON.parse(localStorage.getItem('search-recent'))
      : '';
    return Array.isArray(recentSearches)
      ? recentSearches.filter((v) => v && v.trim())
      : [];
  } catch (e) {
    return [];
  }
}
function renderInitialSearch() {
  const popularSearches = getPopularSearch();
  const recentSearches = getRecentSearch();
  let content = `
    ${
      popularSearches?.length
        ? ` <p class="title">Trending Searches</p> <div class='popular-search-wrapper'>
            ${popularSearches
              .map(
                (item) =>
                  `<li><a href="/pages/search-results-page/?q=${encodeURIComponent(
                    item,
                  )}" class="popular-search-item">
                ${trendingImg}
                ${item}</a></li>`,
              )
              .join(' ')}</div>
        `
        : ''
    }
    ${
      recentSearches?.length
        ? ` <p class="title">Recent Searches</p> <div class='recent-search-wrapper'>
            ${recentSearches
              .map(
                (item) =>
                  `<li><a href="/pages/search-results-page/?q=${encodeURIComponent(
                    item,
                  )}" class="recent-search-item">
                ${recentImg}
                <span>${item}</span></a></li>`,
              )
              .join(' ')}</div>
        `
        : ''
    }
  `;
  $('.app_results_container, .app_results_container-mb').html(content);
  setTimeout(() => {
    const popularSearch = window.Searchanise?.preloadedSuggestions;

    if (popularSearch?.length) {
      localStorage.setItem(
        'popularSearch',
        JSON.stringify(popularSearch.slice(0, 5)),
      );
    }
  }, 1000);
}
function getPersonalizationSearch() {
  const defaultData = {
    recentlyViewedProducts: [],
    recentlyAddedToCartProducts: [],
    recentlyPurchasedProducts: [],
  };
  try {
    const personalization = localStorage.getItem('Personalization');
    return personalization ? JSON.parse(personalization) : defaultData;
  } catch (err) {
    return defaultData;
  }
}
const debounceSearch = (fn, delay = 1000) => {
  let timerId = null;
  return (...args) => {
    clearTimeout(timerId);
    timerId = setTimeout(() => fn(...args), delay);
  };
};
const onInputSearch = debounceSearch(handleSearch, 0);
function getSearchResultsFromPreload(searchTemp) {
  const popularSearch = window.Searchanise?.preloadedSuggestions;
  if (!popularSearch?.length) {
    return [];
  }
  return popularSearch
    .filter((p) => p.includes(searchTemp))
    .slice(0, limitSearchResult)
    .map((value) => {
      if (value.split(' ').length > 10) {
        let splitString = value.split(searchTemp);
        if (splitString.length > 1) splitString.shift();
        return splitString.length > 0
          ? `${searchTemp}${splitString[0]}`
          : value;
      }
      return value;
    });
}
function renderResultSearch(res, searchText, items = []) {
  if (!res || !Array.isArray(res.suggestions)) return;
  const search = searchText.trim().replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const re = new RegExp(search, 'gi');

  // Render Suggestions
  const suggestionsHtml = res.suggestions
    .map((item) => {
      const highlightedText = item.replace(re, `<mark>$&</mark>`);
      return `
        <a href="/pages/search-results-page/?q=${encodeURIComponent(
          item,
        )}" 
           class="suggestion-search-item" 
           title="${item}">
          ${searchImg} <span>${highlightedText}</span>
        </a>`;
    })
    .join('');

  // Render  Products
  const productsHtml = items?.length
    ? items
        .map(
          (item) => `
          <a href="${item.link}">
            <img src="${item?.image_link}" alt="${item.title}" />
            <p>${item.title}</p>
          </a>`,
        )
        .join('')
    : '';

  const content = `
    <div class="suggestion-search-wrapper">
      <div class="suggestions">Suggestions</div>
      ${suggestionsHtml}
      <div class="suggestions ${
        items?.length === 0 ? 'hidden' : 'show'
      }">Products</div>
      ${productsHtml}
    </div>`;

  $('.app_results_container-mb').html(content);
  $('.suggestion-search-item').click(function (e) {
    e.preventDefault();
    const href = $(this).attr('href');
    const formValue = $(this).attr('title');
    const listRecentSearch = getRecentSearch();
    if (!listRecentSearch.includes(formValue)) {
      listRecentSearch.unshift(formValue);
      localStorage.setItem(
        'search-recent',
        JSON.stringify(listRecentSearch.splice(0, 3)),
      );
    }
    window.location.href = href;
  });
}

function renderNotFound(searchText) {
  let content = ` <div class="not-found-wrapper"> <p class="title">Sorry, nothing found for <span>${searchText}</span>.</p> </div>
  `;
  $('.app_results_container-mb').html(content);
}
function renderProducts(res) {
  const productsHtml = res?.items?.length
    ? res?.items
        .map(
          (item) => `
        <a href="${item.link}">
          <img src="${item?.image_link}" alt="${item.title}" />
          <p>${item.title}</p>
        </a>`,
        )
        .join('')
    : '';

  const content = `
    <div class="suggestion-search-wrapper">
      <div class="suggestions ${
        res?.items?.length === 0 ? 'hidden' : 'show'
      }">Products</div>
      ${productsHtml}
    </div>`;

  $('.app_results_container-mb').html(content);
}
async function handleSearch(inputElement) {
  try {
    const baseUrl = 'https://www.searchanise.com/getwidgets';
    const apiKey = '4M1G0o2c6c';

    const personalizationSearchData = getPersonalizationSearch();
    let currentTextSearch = inputElement.val();
    if (!currentTextSearch) {
      renderInitialSearch();
      return;
    }
    const preloadSearch = getSearchResultsFromPreload(currentTextSearch);
    const lengthPreloadSearch = preloadSearch.length;
    if (lengthPreloadSearch > 0) {
      renderResultSearch({ suggestions: preloadSearch }, currentTextSearch);
    }
    const myParams = {
      api_key: apiKey,
      q: currentTextSearch,
      maxResults: 3,
      startIndex: 0,
      items: true,
      pages: false,
      facets: false,
      categories: false,
      suggestions: true,
      vendors: false,
      tags: false,
      pageStartIndex: 0,
      pagesMaxResults: 0,
      categoryStartIndex: 0,
      categoriesMaxResults: 0,
      suggestionsMaxResults: limitSearchResult,
      vendorsMaxResults: 0,
      tagsMaxResults: 0,
      ...personalizationSearchData,
    };
    const queryString = new URLSearchParams(myParams).toString();
    const rawResponse = await fetch(`${baseUrl}?${queryString}`);
    const res = await rawResponse.json();
    currentTextSearch = inputElement.val();
    if (!currentTextSearch) {
      renderInitialSearch();
      return;
    }

    if (!res?.suggestions?.length) {
      if (res?.items?.length > 0) {
        renderProducts(res);
      } else if (!lengthPreloadSearch) {
        renderNotFound(currentTextSearch);
      }
    } else {
      if (lengthPreloadSearch < limitSearchResult) {
        const suggestionsRender = [
          ...new Set([...res.suggestions, ...preloadSearch]),
        ].slice(0, limitSearchResult);
        renderResultSearch(
          { suggestions: suggestionsRender },
          currentTextSearch,
          res?.items,
        );
      }
    }
  } catch (e) {
    console.log('error', e);
  }
}
const limitSearchResult = 10;
$(document).ready(function () {
  $(".header__search input[type='search']").click(function () {
    const $parent = $(this).closest('.search_container');
    if (!$(this).val()) {
      $parent.find('.search_results_overlay').show();
      $parent.find('.app_results_container').show();
    }
    renderInitialSearch();
  });

  $('.search-modal__close-button').click(function () {
    $(
      '.search_results_overlay-mb,.app_results_container-mb,.closed-modal-search',
    ).show();
    $('.search-modal').addClass('show');
    renderInitialSearch();
    $('.search_form_mb input').focus();
    if ($('.search_form_mb input').val()) {
      const inputElement = $('.search_form_mb input');
      onInputSearch(inputElement);
    }
  });

  $('.header__search .search_form_mb ,.search.hidden-xs').on(
    'submit',
    function (e) {
      e.preventDefault();
      const formValue = $(this).find('input').val();
      if (formValue && formValue.trim()) {
        const listRecentSearch = getRecentSearch();
        if (!listRecentSearch.includes(formValue)) {
          listRecentSearch.unshift(formValue);
          localStorage.setItem(
            'search-recent',
            JSON.stringify(listRecentSearch.splice(0, 3)),
          );
        }
      }
      const cleanFormValue = encodeURIComponent(formValue);
      window.location.href =
        '/pages/search-results-page/?q=' +
        cleanFormValue;
    },
  );
  $('body').on(
    'input',
    '.header__search.search_container .search__input.field__input',
    function (e) {
      const value = e.target.value;
      if (value) {
        $('.search_results_overlay').hide();
        $('.app_results_container,.closed-modal-search').hide();
      } else {
        $('.search_results_overlay').show();
        $('.app_results_container').show();
        if (!$('.app_results_container .popular-search-item').length) {
          renderInitialSearch();
        }
      }
    },
  );

  $('.search_form_mb input[type="text"]').on('paste', function (e) {
    const inputElement = $(this);
    onInputSearch(inputElement);
  });
  $('body').on('input', '.search_form_mb input[type="text"]', function (e) {
    const inputElement = $(this);
    onInputSearch(inputElement);
  });

  $('.search_results_overlay-mb,.closed-modal-search').click(function () {
    $(
      '.search_results_overlay-mb,.app_results_container-mb,.closed-modal-search',
    ).hide();
    $('.search-modal').removeClass('show');
  });

  var target = $('.grid__item.product__media-wrapper');
  var btnPreview = $('.btn-preview');

  $(window).on('scroll', function () {
    if (
      window.innerWidth > 1024 ||
      (btnPreview && !btnPreview.length) ||
      (target && !target.length)
    )
      return;

    var targetOffset = target.offset().top + target.height();
    var scrollPosition = $(window).scrollTop() + $(window).height();
    if (scrollPosition - 150 >= targetOffset) {
      btnPreview.fadeIn();
      btnPreview.removeClass('hidden');
    } else {
      btnPreview.fadeOut();
      btnPreview.addClass('hidden');
    }
  });
});

$(document).on('click', function (e) {
  if (!$(e.target).closest('.header__search.search_container').length) {
    $('.search_results_overlay').hide();
    $('.app_results_container,.closed-modal-search').hide();
  }
});